export default __webpack_public_path__ + "static/media/a037-8.553c4583.svg";